import generateTypes from '../utils/generateTypes';

export const GET_INTERACTIVE_MAP = generateTypes('GET_INTERACTIVE_MAP');
export const RESET_INTERACTIVE_MAP = generateTypes('RESET_INTERACTIVE_MAP');
